export default __webpack_public_path__ + "static/media/louisiana.2f0eda79.jpg";